import React, { PureComponent, lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import { ThemeProvider, Button, Dropdown } from '@workboard/wobo-ui';
import qs from 'qs';
import GoalServices from '../../../services/goal.services';
import OkrComp from '../../okr.component';
import KrShowCollapse from '../okr_depend_components/krShowCollapse.component';
import Filters from '../okr_sub_components/filters.component';
import { okrDetailActions } from '../../../actions/okr/okrDetails.actions';
import { okrDetailConstants } from '../../../constants/okr/okrDetails.constants';
import { getExternalAppsFeatureFlag } from './../../../utils/kpi-market-place-util';

const ShowOverDueKrs = lazy(() => import(
  /* webpackChunkName: "showOverDueKr" */
  '../okr_depend_components/showOverDueKr.component'
));
const OneLineAlignmentButtonComp = lazy(() => import(
  /* webpackChunkName: "oneLineAlignmentButton" */
  '../../oneLineAlignment/oneLineAlignmentButton'
)) ;
const OkrTimeLineAlignButton = lazy(() => import(
  /* webpackChunkName: "okrTimeLineButton" */
  '../../button/okrTimeLineButton.component'
));

const StyledDropdown = styled(Dropdown)`
	margin: 10px 15px;
	min-width: 155px !important;
	width: unset !important;
  > svg {
    margin-right: 10px !important;
  }
`;
class MyGoalContainer extends PureComponent {
	constructor(props) {
		super(props);
		const { data = {}, type } = props;
		// const dataShowOption = this.getTabElementAttrs();
		let showOption;
    this.searchKrFilter = (type == okrDetailConstants.PAGE_TYPE_KR_I_UPDATE 
      || type == okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH 
      || type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR);
		if(this.searchKrFilter){
			showOption = this.props.krOwnUpdate ? this.props.krOwnUpdate : 0;
		}else{
			showOption = typeof this.props.okrPreferences !== "undefined" && typeof this.props.okrPreferences.filters !== "undefined"
					? this.props.okrPreferences.filters.show
					: 2;
		}
		
			
		this.state = {
			showOption,
			showGoalMetricList: true,
			openObjectiveFilter: false,
			dueStatus: this.props.dueStatus,
			params: {},
			filterCount: false,
			openSelect: false,
			notificationsData: []
		};
		this.filterData = {
			//date filter and status state variables
			goalStatus: "1",
			startDate: null,
			endDate: null,
			performance: okrDetailConstants.FILTER_PROGRESS_DEFAULT,
			categories: ''
		  };

		this.GoalServices = new GoalServices();
		this.updateGoalItems = this.updateGoalItems.bind(this);
		this.onChangeFilters = this.onChangeFilters.bind(this);
		this.closeObjectiveFilter = this.closeObjectiveFilter.bind(this);
		// this.OkrComp = React.createRef();
		window.MyGoalContainer = this;
		// console.log('MyGoalContainer');
		this.startDate = "",
		this.endDate = "",
		this.exDate = "",
		this.goalStatus = 1;
		this.performance = okrDetailConstants.FILTER_PROGRESS_DEFAULT;
		this.categories = '';
		this.initPendoVisitorReport = this.initPendoVisitorReport.bind(this);
	}


	componentWillMount() {
		document.body.removeEventListener("click", this.closeObjectiveFilter);
	}

	componentDidMount() {
		this.setErrorNotificationFlags();
		this.initPendoVisitorReport();
	}

	initPendoVisitorReport() {
		if (this.props.isPendoEnabled) {
			window.trackPendoVisitorReport?.();
		}
	}

	setErrorNotificationFlags() {
		this.setState({ notificationsData: getExternalAppsFeatureFlag('errorNotification', true) });
	}

	setTabElementAttrs(value) {
		const ele = document.querySelector("#my-okrs-wbtab");
		if (ele) {
			ele.setAttribute("data-show-otion", value);
		}
	}

	getTabElementAttrs() {
		const ele = document.querySelector("#my-okrs-wbtab");
		let value = "";
		if (ele) {
			value = ele.getAttribute("data-show-otion");
		}
		return value;
	}

	updateOkrFilterVal =(start_date, end_date, status, performance, category)=> {
		this.filterData = Object.assign({}, this.filterData, {
		  goalStatus: status,
		  startDate: start_date,
		  endDate: end_date,
		  performance: performance,
		  categories: category
		});
	}

	resetGoalsData =()=>{
		this.props.dispatch({type: okrDetailConstants.RESET_GOAL_DATA});
	}

	onChangeFilters(e, item) {
		if (typeof item !== "undefined") {
			const itemValue = e.target.value;
			showLoaderWidget($("#content"));
			const _this = this;
			// if(typeof window.ObjectiveFilter !== 'undefined' && window.ObjectiveFilter !== null){
			// 	window.ObjectiveFilter.clearFilter(false, true);
			// }
			// _this.getFilterData(this.props.filterDataSet);

			let goalStat = _this.goalStatus;
			if (_this.goalStatus == '3') {
				goalStat = "1, 2";
			}
			const isKRUpdateFilter = (this.props.type == okrDetailConstants.PAGE_TYPE_KR_I_UPDATE || this.props.type == okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH || this.props.type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR);
			if (!isKRUpdateFilter) {
				_this.props.dispatch({type: okrDetailConstants.RESET_HANDLE_OVERDUE_KR});
			}
			let params = {
				status: goalStat,
				startDate: _this.startDate,
				endDate: _this.endDate,
				exDate: _this.exDate
			};

			setTimeout(() =>{
				if(isKRUpdateFilter){
          const { startDate, endDate, exDate, performance } = this.state.params;
					params.kr_own_update= itemValue;
          params.startDate = startDate;
          params.endDate = endDate;
          params.exDate = exDate;
          params.performance = performance;
					if(this.props.type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR){
						params.flag = 2;
						//let krParams = {goalId: goalId,metricId:metricId,overDue: this.props.dueStatus}
						this.props.dispatch(okrDetailActions.getMyDirectsKR(params));
					}else if(this.props.type == okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH){
						params.flag = 3;
						params.offset = 0;
						params.json = true;
						params.id = this.props.teams.encryptID;
						params.refSrc =  "PERSON_KR";
						this.props.dispatch(okrDetailActions.getFilteredPersonKrs(params));
						// this.props.dispatch({type: okrDetailConstants.UPDATE_PERSON_SEARCH_RESULT,params})
					}
				}else{
					params.f = itemValue;
					_this.props.dispatch(okrDetailActions.getMyGoalsFiltered(params));
					_this.GoalServices.saveMyOkrFilters({ show_option: itemValue, refSrc: 'SHOW_TEAMS_MANAGE_COMANAGE_USED'});
				}
				_this.setState(
					{
						showOption: itemValue,
					},
					() => {
						_this.setTabElementAttrs(itemValue);
					}
				);
			},0)
		}
	}

	updateGoalItems(args) {
		if (typeof args.goalId !== "undefined") {
			const { goalId,metricId="" } = args;
			if (goalId) {
				const actionType =
					typeof args.action !== "undefined" ? args.action : "";
				if (actionType == "new" || actionType == "edit" ) {
					this.getGoalData(goalId, actionType,metricId);
				} else if (actionType == "closeGoal" || actionType == "reopenGoal") {
					if (this.props.filterDataSet) {
						if (this.props.filterDataSet.statusSet) {
							this.getGoalData(goalId, "editCurrent");
						} else if(this.props.filterDataSet.onlyClosedGoals && !this.props.filterDataSet.onlyOpenGoals && actionType == "reopenGoal") {

							const rows = this.props.teams
								.map(row => {
									row.goals = row.goals.filter(goal => goal.id != goalId);
									return row;
								})
								.filter(r => r.goals.length);
								
							let data = {data: rows}
							this.props.dispatch({type:okrDetailConstants.UPDATE_GOAL_DETAILS_SUCCESS,data});

						} else if (this.props.filterDataSet.onlyOpenGoals && !this.props.filterDataSet.onlyClosedGoals && actionType == "closeGoal") {
							
							const rows = this.props.teams
								.map(row => {
									row.goals = row.goals.filter(goal => goal.id != goalId);
									return row;
								})
								.filter(r => r.goals.length);
							let data = {data: rows}
							this.props.dispatch({type:okrDetailConstants.UPDATE_GOAL_DETAILS_SUCCESS,data});
						}else{
							let actType = "edit";
							this.getGoalData(goalId, actType,metricId);
						}
					}

				} else if (actionType == "delete") {
					if(this.props.type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_OKR){
						let data ={goalId: goalId}
						this.props.dispatch({type:okrDetailConstants.DIRECT_DOTTED_OKR_DELETE_SUCCESS,data});
					}else {
						const rows = this.props.teams
							.map(row => {
								row.goals = row.goals.filter(goal => goal.id != goalId);
								return row;
							})
							.filter(r => r.goals.length);
							let data = {data: rows}
							this.props.dispatch({type:okrDetailConstants.UPDATE_GOAL_DETAILS_SUCCESS,data});
					}
				} else if(actionType == "deletekr"){
					if(this.props.type == okrDetailConstants.PAGE_TYPE_KR_I_UPDATE || this.props.type == okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH){
						let data = {id: metricId}
						this.props.dispatch({type:okrDetailConstants.DELETE_SINGLE_KR,data});
					}else if(this.props.type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR){
						let data = {id: metricId}
						this.props.dispatch({type:okrDetailConstants.DELETE_DIRECT_DOTTED_KR,data});
					}else{
						let actType = "edit";
						this.getGoalData(goalId, actType,metricId);
					}
				}else if(actionType == "createCascade"){
					// let data = args.metricId;
					// let params = {goalId: args.goalId,metricId: data}
					// this.props.dispatch({type: okrDetailConstants.REMOVE_CREATE_CASCADE_CARD,data});
					// this.props.dispatch(okrDetailActions.updateCascadeKrList(params));
				}else if(actionType == 'deleteCascadeKr'){
					let data = args.metricId;
					this.props.dispatch({type: okrDetailConstants.DELETE_CASCADE_KR_FROM_LIST,data});
				}
				
			}
		}
	}

  getRequestParams()
  {
     const { startDate = '', 
     endDate = '', 
     exDate = 0, 
     categories = '',
     performance = '',
     onlyOpenGoals = true,
     onlyClosedGoals = false
     } = this.props.filterDataSet || {};
     let statusVal = [];
     if (onlyOpenGoals) {
       statusVal.push(1);
     }
     if (onlyClosedGoals) {
       statusVal.push(2);
     }
     if (statusVal.length == 0) {
       statusVal.push(1);
     }
     return {
      status: statusVal.join(','),
      startDate,
      endDate,
      exDate,
      categories,
      performance
     }
  }

	getGoalData(goalId, actionType = "",metricId="") {
		const _this = this;
		const { type } = this.props;
		let params = {};
		params.goalId = goalId;
		if(type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_OKR){
			params.actionType = actionType;
			_this.props.dispatch(okrDetailActions.getDirectDottedSingleGoal(params));
		}
		else if(type == okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH){
			let krParams = {goalId: goalId,metricId:metricId,overDue: this.props.dueStatus}
			this.props.dispatch(okrDetailActions.getSingleKrDetails(krParams));
			
		}else if(type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR){
			let krParams = {goalId: goalId,metricId:metricId,overDue: this.props.dueStatus}
      krParams = {...krParams, ...this.getRequestParams()}
			this.props.dispatch(okrDetailActions.updateDirectDottedKr(krParams));
		}else{
				if(type == okrDetailConstants.PAGE_TYPE_TEAM_TAB_OKR){
					params.depCount = true;
				}
				if(this.props.dueStatus){
					params.overdueKR = this.props.dueStatus
				}
			params = {...params, ...this.getRequestParams()}
			this.GoalServices.getGoalData(params).then(response => {
				if (response.data) {
					const _goals = response.data.goals;
					let _rows1 = _this.props.teams || [];
					if (typeof _goals[0] !== "undefined" && _goals[0] != null) {
						const _goal = _goals[0];
						// console.log('actionType', actionType);
						
						const teamId = parseInt(_goal.team_id) > 0 ? _goal.team_id : "0";
						const isNewGoal = _rows1.find(
							row =>
								row.team_id == teamId &&
								row.goals.find(goal => goal.id == _goal.id)
						);
						if (!isNewGoal) {
							actionType = "new";
							// if user convert to personal okr and viceversa, in this case remove goal from existing object.
							_rows1 = _rows1.map(row => {
								row.goals = row.goals.filter(g => g.id != _goal.id);
								return row;
							});
						}
						if (actionType == "edit" || actionType == "editCurrent") {
							const goalStatus = _goal.status;
							if (goalStatus == "1" || actionType == "editCurrent") {
								_rows1 = _rows1.map(row => {
									if (row.team_id == teamId) {
										row.goals = row.goals.map(goal => {
											if (goal.id == _goal.id) {
												goal = Object.assign({}, goal, _goal);
											}
											return goal;
										});
									}
									return row;
								});
							} else {
								_rows1 = _rows1.map(row => {
									if (row.team_id == teamId) {
										row.goals = row.goals.filter(goal => goal.id != _goal.id);
									}
									return row;
								});
								_rows1 = _rows1.filter(row => row.goals.length);
							}
							let data = {data: _rows1}
							// console.log("Data",data);
							_this.props.dispatch({type:okrDetailConstants.UPDATE_GOAL_DETAILS_SUCCESS,data});
							if (
								typeof _this.OkrComp !== "undefined" &&
								_this.OkrComp !== null
							) {
								_this.OkrComp.reloadOkr({}, goalId);
							}
							// $(document).trigger('okr_reload_comp', [goalId]);
						} else if (actionType == "new") {
							
								 if (Object.keys(_goal).length) {
									 if(teamId !== _rows1[0].team_id && this.props.type == okrDetailConstants.PAGE_TYPE_TEAM_TAB_OKR){
										return _rows1;
									 }else{
										 let existingGroup = false;
										 const newRowTobeAdded = this.checkForOKRfilter(_this.props.filterDataSet, _goal);
										 if (newRowTobeAdded) {
											const isAddGoal = ((_goal.type == 2 && this.props.userData.id == _goal.user_id) || _goal.type == 1);
										 _rows1 = _rows1.map(row => {
											 if (row.team_id == teamId) {
												 existingGroup = true;
												 if (isAddGoal) {
													row.goals = [_goal,...row.goals];
												 }
											 }
											 return row;
										 });
										 
										//  if(this.props.type !== okrDetailConstants.PAGE_TYPE_OKR_I_OWN){
											//If team doesn't exist then add new Team with new goal data 
											if (!existingGroup) {
											 //  console.log("comes hereee");
												 const group = {
													 team_id: teamId,
													 name: (_goal.type == 2 ? 'Personal' : _goal.teamName),
													 goals: [_goal]
												 };
												 _rows1 = [..._rows1,group];
											 }
										//  }
									 }
							 }
							 }
								//
								let data = {data: _rows1}
								_this.props.dispatch({type:okrDetailConstants.UPDATE_GOAL_DETAILS_SUCCESS,data});
							
						}
					} else if (this.props.dueStatus) {
						_rows1 = _rows1.map(row => {
							row.goals = row.goals.filter(g => g.id != goalId);
							return row;
						});

						let data = {data: _rows1}
						_this.props.dispatch({type:okrDetailConstants.UPDATE_GOAL_DETAILS_SUCCESS,data});
					}
				}
			});
		}
		
	}

	checkForOKRfilter = (filterData, newGoal) => {
		let new_start_date = moment(parseInt(newGoal.start_date)*1000).format('MM/DD/YYYY');
		let new_end_date = moment(parseInt(newGoal.target_date)*1000).format('MM/DD/YYYY');
		let startDateFlag = moment(new_start_date).isAfter(filterData.endDate) && moment(new_start_date).isBefore(filterData.endDate) ? true : false;
		let endDateFlag = moment(new_end_date).isAfter(filterData.endDate) && moment(new_end_date).isBefore(filterData.endDate) ? true : false;
		let filterStatus = '';
		if (filterData.onlyOpenGoals) {
			filterStatus = '1'
		}
		if (filterData.onlyClosedGoals) {
			if (filterStatus != "") {
				filterStatus += ",";
			}
			filterStatus += "2";
		}
		if (filterStatus.includes(newGoal.status)) {
			if (filterData.exDate == 1) {
				
				if((filterData.startDate == null || filterData.startDate == undefined || filterData.startDate == "") && (filterData.endDate == null || filterData.endDate == undefined || filterData.endDate == "")){
					return true;
				}

				if((new_start_date == filterData.startDate && (filterData.endDate == null || filterData.endDate == undefined || filterData.endDate == "")) || (new_end_date == filterData.endDate && (filterData.startDate == null || filterData.startDate == undefined || filterData.startDate == ""))){
					return true;
				}
				
				if (new_start_date == filterData.startDate && new_end_date == filterData.endDate) {
					return true;
				} else return false
			} else {
				
				if((filterData.startDate == null || filterData.startDate == undefined || filterData.startDate == "") && (filterData.endDate == null || filterData.endDate == undefined || filterData.endDate == "")){
					return true;
				}

				if((new_start_date == filterData.startDate && (filterData.endDate == null || filterData.endDate == undefined || filterData.endDate == "")) || (new_end_date == filterData.endDate && (filterData.startDate == null || filterData.startDate == undefined || filterData.startDate == ""))){
					return true;
				}

				if ((new_start_date == filterData.startDate || startDateFlag) && (new_end_date == filterData.endDate || endDateFlag)) {
					return true;
				} else return false
			}
		} else return false
	}
	componentWillReceiveProps(nextProps) {
		// console.log("NextProps",nextProps);
		if(this.state.dueStatus !== nextProps.dueStatus){
			this.setState({
				...this.state,
				dueStatus: nextProps.dueStatus
			});
		}
		if(this.props.type == okrDetailConstants.PAGE_TYPE_KR_I_UPDATE || this.props.type == okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH || this.props.type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR){
			if(this.state.showOption !== nextProps.krOwnUpdate){
				this.setState({
					...this.state,
					showOption : nextProps.krOwnUpdate
				})
			}
		}
		
		// if (nextProps.data.myOkrStatus != this.props.data.myOkrStatus) {
		// 	this.getMyGoals(nextProps.data.myOkrStatus);
		// 	// console.log(nextProps.data.myOkrStatus,"nextProps.data.myOkrStatus");
    	// 	}
    // this.setState({
    //   rows: nextProps.rows != undefined ? nextProps.rows : [],
    //   filterData: nextProps.filterDataSet,
    //   filterCount: nextProps.count == 0 ? "" : nextProps.count
    // })
	}

	closeObjectiveFilter(e) {
		// check if the calendar is open
		if (this.state.openObjectiveFilter) {
			let currNode = e.target;
			let inCalendarFilter = false;
			if(currNode && currNode.parentNode){
				while (currNode.parentNode !== document.body) {
					if ( currNode.parentNode && currNode.parentNode.classList && currNode.parentNode.classList.contains("calendar-filter")) {
						inCalendarFilter = true;
					}
					currNode = currNode.parentNode;
				}
			}
			
			if (!inCalendarFilter) {
				this.setState({
					openObjectiveFilter: false
				});
			}
		}
	}

	handleOkrCollapse = () => {
		let okrPages = [okrDetailConstants.PAGE_TYPE_OKR_I_OWN,okrDetailConstants.PAGE_TYPE_MY_MANAGER_OKR,okrDetailConstants.PAGE_TYPE_MY_TEAM_OKR];
		let teamsPages= [okrDetailConstants.PAGE_TYPE_TEAM_TAB_OKR,okrDetailConstants.PAGE_TYPE_JUMP_TO_OKR,okrDetailConstants.PAGE_TYPE_MY_DIRECT_OKR];
		let params ={};
		let status = !this.props.showGoalMetricList ? 1 : 0;
		if(okrPages.includes(this.props.type)){
			Object.assign(params,{'okrExpCol': status, 'refSrc':'SHOW_HIDE_KR_USER'});
		}else if(teamsPages.includes(this.props.type)){
			Object.assign(params,{'teamExpCol': status, 'refSrc':'SHOW_HIDE_KR_USER'});
		}
		this.GoalServices.saveOkrExpandCollapse(params);
		this.props.dispatch({type: okrDetailConstants.UPDATE_SHOW_HIDE_METRIC});
	}

	handleOverDue = () => {
		// let params = {overdueKR: !this.state.dueStatus }
		
		if(typeof this.props.params !== 'undefined' && typeof this.props.params.offset !== 'undefined'){

			this.props.params.offset = 0;
		}
		this.props.dispatch({type: okrDetailConstants.HANDLE_OVERDUE_KR});
		if(typeof window.OkrComp !== 'undefined'){
			window.OkrComp.resetStateOffset();
		}
		this.props.dispatch({ type: okrDetailConstants.RESET_GOAL_DATA });
		
	}

	getFilterData =(filterDataSet) =>{
		if(typeof filterDataSet !== 'undefined' && filterDataSet !== null && filterDataSet !== ""){
			this.startDate = filterDataSet.startDate;
			this.endDate = filterDataSet.endDate;
			if (filterDataSet.exDate && filterDataSet.exDate != '') {
				this.exDate = filterDataSet.exDate;
			} else if(filterDataSet.exDate == 0 || filterDataSet.exDate == '') {
				this.exDate = 0;
			}
			if(filterDataSet.onlyClosedGoals && filterDataSet.onlyOpenGoals){
				this.goalStatus = "3";
			}
			else if(filterDataSet.onlyClosedGoals && !filterDataSet.onlyOpenGoals){
				this.goalStatus = "2";
			}else if(!filterDataSet.onlyClosedGoals && filterDataSet.onlyOpenGoals){
				this.goalStatus = "1";
			}
			if(filterDataSet.performance) {
				this.performance = filterDataSet.performance;
			}
			if(filterDataSet.categories) {
				this.categories = filterDataSet.categories;
			}

			
		}else{
			this.goalStatus = "1";
		}
	}

	handleOpenSelect = (open) => {
		this.setState({openSelect : open})
		const targetEl = document.getElementById('okrPage-select-button-button');
		if(open){
			targetEl?.classList.add('okr-team-select-no-outline')
		} else {
			targetEl?.classList.remove('okr-team-select-no-outline')
		}
	}
	
	render() {
		const { t, type, filterOptions, isSortingEnable, showALignmentButton, progressType, showTeamName, 
      showRealOwner, showShortCutBar, showOkrDependencyAlignment, showGoalName, showUserName,
      goalsData, fullAlignData, pagination, paginationLimit,showSourceName, showTimeLineButton, params,
      data = {}
    } = this.props;
    const isReloadTab = data.isReloadTab || false;

		const KrFilterOptions = [
			{
				name: `${t('Key results they update')}`,
				value: "1"
			},
			{
				name: `${t('Key results they own')}`,
				value: "2"
			},
			{
				name: `${t('Key results they own or update')}`,
				value: "3"
			}
		];
		let timeLinkLink = "";
		let idForAlignment = "";
		
		if(typeof this.props.teamId !== 'undefined' && this.props.teamId != ''){
			timeLinkLink += wbConfig.baseUrl+"/goal/goalTimeLine?refSrc='OKR_TIMELINE_VIEWED'&type='TEAM_OKR'&t=" + this.props.teamId;
			idForAlignment += "team-"+this.props.teamId;
		}else if(typeof this.props.userId !== 'undefined' && this.props.userId != ''){
			timeLinkLink += wbConfig.baseUrl+"/goal/goalTimeLine?refSrc='OKR_TIMELINE_VIEWED'&type='TEAM_OKR'&u=" + this.props.userId;
			idForAlignment = "user-"+this.props.userId;
		}
		this.getFilterData(this.props.filterDataSet);

		let filterOptionsToRender;
		let showFilterControl;
		if(this.props.showManagerFilter){
			if(showRealOwner){
				showFilterControl = true;
				if(this.props.type == okrDetailConstants.PAGE_TYPE_KR_I_UPDATE){
					filterOptionsToRender = KrFilterOptions.map((f) => {
						return {
							name: f.name.replace(/they/gi, "I"),
							value: f.value
						}
					});
				}else if(this.props.type == okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH || this.props.type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR){
					filterOptionsToRender = KrFilterOptions;
				}else{
					filterOptionsToRender = filterOptions;
				}	
			}else{
				if(this.props.type == okrDetailConstants.PAGE_TYPE_KR_I_UPDATE || this.props.type == okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH || this.props.type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR){
					showFilterControl = false;
				}else{
					showFilterControl = true;
					filterOptionsToRender = filterOptions;
				}
			}
		}
		let filterParamsList = this.props.paramsList || this.props.params;
    if (this.props.type == okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH) {
      filterParamsList = Object.assign(filterParamsList, {id: this.props.teams.encryptID, json: true});
    }
    let passOKRparams = this.props.params || {};
    if (this.searchKrFilter) {
      passOKRparams = Object.assign(passOKRparams, this.getRequestParams())
    }

	const parseUrl = qs.parse(window.location.search, { ignoreQueryPrefix: true });
	const { nextAlignment = 0, teamId, userId, gType } = parseUrl;
	// next alignment slider id from unique url at first load.
	const idForAlignmentFromURL = nextAlignment ? (teamId ? "team-"+teamId 
		: (gType == 2 ? 'personal-user-' + userId : 'user-' + userId)) : null;
	
		return (
			<ThemeProvider>
			<div id="goal_index_page" className={`my_goals_tab ${this.props.type.toLowerCase()}_pagination  ${progressType ? progressType.toLowerCase() : okrDetailConstants.PROGRESS_TYPE_CIRCLE.toLowerCase()}`}>
				<div className="my_goals_tab_controls">
					<div className="left-controls">
					<input
							type="hidden"
							id="myokr_filter_option"
							value={this.state.showOption}
						/>
						{showALignmentButton && (typeof this.props.teams !== 'undefined' && this.props.teams && this.props.teams.length > 0) &&
							<Suspense fallback={null} >
								<OneLineAlignmentButtonComp
									dispatch = {this.props.dispatch}
									fullAlignData = {fullAlignData}
									sid = {idForAlignment}
									startDate={this.startDate}
									endDate={this.endDate}
									exDate={this.exDate}
									status={this.goalStatus}
									//nextAlignment={nextAlignment}
									//idForAlignment={idForAlignmentFromURL}
								/>
							</Suspense>
						}

						{showTimeLineButton &&
							<Suspense fallback={null}>
								<OkrTimeLineAlignButton 
									toLink={timeLinkLink}
								/>
							</Suspense>
						}
						
					
						{this.props.showManagerFilter && showFilterControl && this.state.showOption ?
							<div style={{display: "flex", alignItems:"center"}} className="main-select">
								<label id="okrPage-select-label">{t("Show")}:</label>
								<StyledDropdown
									id="okrPage-select-button"
									aria-label={`${t('This listbox lets you filter your OKRs by the selected option')}`}
									autoMenuWidth
									className="okr-team-select"
									options = {filterOptionsToRender}
									onChange={this.onChangeFilters} 
									value={this.state.showOption !== null && typeof this.state.showOption !== 'undefined' ? this.state.showOption.toString() : ''}
									optionTitleProp="name"
									optionValueProp="value"
								/>
							</div>
						 : ""
						}
					</div>
					{this.props.type !== okrDetailConstants.PAGE_TYPE_WS_TAB_OKR ?
						<div className="right-controls">
							{ 
							this.props.type !== okrDetailConstants.PAGE_TYPE_KR_I_UPDATE ?
								this.props.onlyShowOverDueFilter ?
								[
									<Suspense key="overdue-filter" fallback={null}>
									<ShowOverDueKrs checkStatus={this.props.dueStatus === true} handleOverdue={() => this.handleOverDue()} customClass={'overDuekrCheck'} inputText={`${t('Only show overdue key results')}`} /></Suspense>,
									this.props.showHideShowOkr === true
										? <KrShowCollapse key="kr-show-collapse" handleClick={() => this.handleOkrCollapse()} status={this.props.showGoalMetricList} />
										: null,
								]
								:
								[
									(this.props.showGoalMetricList ? <Suspense key="1" fallback={null}><ShowOverDueKrs  checkStatus={this.props.dueStatus === true} handleOverdue={() => this.handleOverDue()} customClass={'overDuekrCheck'} inputText={`${t('Only show overdue key results')}`} /></Suspense> : ""),

									<KrShowCollapse key="2" handleClick={() => this.handleOkrCollapse()} status={this.props.showGoalMetricList} />
								]
									
								: (this.props.type == okrDetailConstants.PAGE_TYPE_KR_I_UPDATE && typeof this.props.teams !== 'undefined' &&
								typeof this.props.teams !== 'undefined' && this.props.teams && ( !this.props.teams.metrics || this.props.teams.metrics.length > 0 )) ?
									this.props.onlyShowOverDueFilter ?
										[
											<ShowOverDueKrs key="overdue-filter" checkStatus={this.props.dueStatus === true} handleOverdue={() => this.handleOverDue()} customClass={'overDuekrCheck'} inputText={`${t('Only show overdue key results')}`} />,
											this.props.showHideShowOkr === true
												? <KrShowCollapse key="kr-show-collapse" handleClick={() => this.handleOkrCollapse()} status={this.props.showGoalMetricList} />
												: null,
										]
									:
										[
											(this.props.showGoalMetricList ? <ShowOverDueKrs key="1" checkStatus={this.props.dueStatus === true} handleOverdue={() => this.handleOverDue()} customClass={'overDuekrCheck'} inputText={`${t('Only show overdue key results')}`} /> : ""),

											<KrShowCollapse key="2" handleClick={() => this.handleOkrCollapse()} status={this.props.showGoalMetricList} />
										]
								: ""
							}
				
							{
								this.props.showFilter ?
									<Filters
									applyUrl={this.props.url}
									updateOkrFilterVal={this.updateOkrFilterVal}
									paramsList={filterParamsList}
									type = {this.props.type}
									showOption={this.state.showOption}
									space = {this.props.space}
									filterCount={this.state.filterCount}
                  					isReloadTab={isReloadTab}
									/>
								:
									<div className="my_goals_tab_spacer" />
							}
						</div>
					: <div className="right-controls">
						<KrShowCollapse key="2" handleClick={() => this.handleOkrCollapse()} status={this.props.showGoalMetricList} />
						</div> 
					}
				</div>
				<div className="clear" />
				{/* <ErrorBoundary> */}
					<OkrComp
						ref={ref => (this.OkrComp = ref)}
						// isGroupOkr={isGroupOkr}
						sorting={isSortingEnable}
						filterFlag={this.props.count? this.props.count : ''}
						showGoalMetric={this.props.showGoalMetricList}
						type={this.props.type}
						showOption={this.state.showOption}
						url={this.props.url}
						params={passOKRparams}
						progressType={progressType}
						showGoalName={showGoalName}
						showTeamName={showTeamName}
						showUserName={showUserName}
						showRealOwner={showRealOwner}
						goalsData={goalsData}
						pagination={pagination}
						paginationLimit={paginationLimit}
						showSourceName={showSourceName}
						showShortCutBar={showShortCutBar}
						showOkrDependencyAlignment={showOkrDependencyAlignment}
						offset={this.props.offset}
       					isReloadTab={isReloadTab}
						fullAlignData={fullAlignData}
						exDate={this.exDate}
						status={this.goalStatus}
						idForAlignment =  {idForAlignmentFromURL}
						notificationsData={this.state.notificationsData}
					/>
				{/* </ErrorBoundary> */}
			</div>
			</ThemeProvider>
		);
	}
}

MyGoalContainer.defaultProps ={
	showTeamName:true,
	showGoalName:true,
	showUserName:false,
	goalsData: [],
	isSortingEnable: false,
	pagination: false,
	paginationLimit: 15,
	showALignmentButton: false,
	showTimeLineButton: false,
	progressType: 'BAR'
}
const filterMapsStateToProps = state => {
  return state.okrDetailsReducer;
};

const enhance = compose(withTranslation(), connect(filterMapsStateToProps,null,null,{forwardRef: true}))
export default enhance(MyGoalContainer);
